import React, { useRef } from "react";
import DownloadExcel from "../../Extra/DownloadExcel";

const TableMaster = ({ data, yearType }) => {
  // const sortedData = [...data].sort(
  //   (a, b) => new Date(a.IC_DATE) - new Date(b.IC_DATE)
  // );

  // const sortedData = [...data].sort((a, b) => a.value - b.value);

  const sortedData = [...data].sort((a, b) =>
    yearType === "MONTHLY_TOP3" || yearType === "PRE_MONTHLY_TOP3"
      ? new Date(a.IC_DATE) - new Date(b.IC_DATE) ||
        (b.value || 0) - (a.value || 0)
      : (b.value || 0) - (a.value || 0),
  );

  return (
    <div className="p-3 m-0 newUiBody">
      <h6
        className=" text-white p-1 rounded"
        style={{ background: " rgba(0, 0, 50, 0.6)" }}
      >
        {yearType.replace(/_/g, " ").replace("TOP3", " ")}
      </h6>
      <div
        style={{
          maxHeight: "165px",
          maxWidth: "130px",
          overflow: "auto",
          fontSize: "11px",
        }}
      >
        <table className="table glassTable ">
          <thead className="table-dark sticky-top">
            <tr>
              {yearType === "MONTHLY_TOP3" ? (
                <>
                  <th>MONTH</th>
                  <th>VALUE</th>
                </>
              ) : yearType === "YEARLY_TOTAL" ? (
                <>
                  <th>YEAR</th>

                  <th>VALUE</th>
                </>
              ) : (
                <>
                  <th>DATE</th>
                  <th>VALUE</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {sortedData.map((item, index) => (
              <tr key={index}>
                {yearType === "MONTHLY_TOP3" && (
                  <td>
                    {item.month_name.slice(0, 3) || "N/A"}-{item.year || null}
                  </td>
                )}
                {yearType === "YEARLY_TOTAL" && <td>{item.year || "N/A"}</td>}
                {yearType === "CURRENT" && (
                  <td>
                    {!item.IC_DATE
                      ? new Date(item.interchange_date).toLocaleDateString(
                          "en-GB",
                        )
                      : new Date(item.IC_DATE).toLocaleDateString("en-GB")}
                  </td>
                )}
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableMaster;
